import BirdsEyeView from "./birdsEyeView";
export default BirdsEyeView;
